import { Text, Icon } from '@msc-b2c/shared-components';
import styles from '../stateroomdetails.module.scss';
import { ExcursionI, PassengerI } from '@msc-b2c/interfaces/interfaces';
import { getPassengersInfoByItem } from '../../utils/stateroomGenericUtils';

interface Props {
  excursions: ExcursionI[];
  passengers: PassengerI[];
  title: string;
  label: string;
  icon: string;
}

const Excursions = ({ excursions, passengers, title, icon, label }: Props) => {
  const getPassengerNames = (item: ExcursionI) =>
    getPassengersInfoByItem(item, passengers).map((p) => `${p.name} ${p.surname}`);

  return excursions.length > 0 ? (
    <div className={styles.excursionsContainer}>
      <Text
        text={title}
        styleOption={styles.excursionsTitle}
      />
      <div className={styles.excursionsWrapper}>
        {excursions.map((exc) => (
          <div
            className={styles.excursion}
            key={exc.code}
          >
            <div className={styles.excursionContent}>
              <Icon icon={icon} />
              <div className={styles.excursionName}>
                <Text text={`${exc.description}:`} />
              </div>
              <Text text={getPassengerNames(exc).join(', ')} />
            </div>
            <div className={styles.excursionLabel}>
              <Text text={label} />
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default Excursions;
